// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box[data-v-632fa33a]{background-color:#fff;border:none;border-radius:4px;box-shadow:none;margin-bottom:20px;min-height:131px;padding:0 24px 24px;position:relative;width:100%}.box[data-v-632fa33a]:hover{background-color:hsla(0,0%,100%,.604);box-shadow:none;box-shadow:0 3px 12px 0 hsla(223,7%,49%,.08)}.box .status[data-v-632fa33a]{position:absolute;right:0;top:0}.box .footer[data-v-632fa33a]{bottom:6px;position:absolute;right:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
